// @flow
import * as React from 'react'
import { P } from '../components/shared'
import { colors } from '@components/shared/colors'
import { B } from '@components/shared'

type PropsType ={
  color?: string,
  textAlign?: 'left' | 'center' | 'right'
}

export default function StoreAvailability (props: PropsType): React.Node {
  return (
    <P color={props.color || colors.midnightBlue} fontSize={'12px'} textAlign={props.textAlign || 'left'} lineHeight={'18px'}>
      <B color={props.color} fontSize={'12px'} lineHeight={'18px'}>Dipsea is available on iOS, Android, and online in the following countries:</B> Argentina, Australia, Austria, Belgium, Brazil, Bulgaria, Canada, Croatia, Cyprus, Czech Republic, Denmark, Ecuador, Estonia, Finland, France, Germany, Greece, Hungary, India, Ireland, Italy, Latvia, Malta, Mexico, Netherlands, New Zealand, Norway, Poland, Portugal, Romania, Slovakia, South Africa, Spain, Sweden, Switzerland, United Kingdom, United States, and Uruguay.
    </P>
  )
}
